export default __webpack_public_path__ + "media/images/gallery/34-a163af0c9dd5643b080192da9c65f294.png";